<template>
  <div class="app-wrap">
    <div :span="24" class="padding24 h100 overflow-x-y">
      <!-- 搜索框start -->
      <div class="search" style="height: 60px">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" @submit.native.prevent>
          <!--历史日志start-->
          <!-- <el-form-item>
            <el-select
              :placeholder="$t('logs.searchInputHistoryLog')"
              style="width: 320px"
              v-model.trim="searchForm.history"
              clearable
            ></el-select>
          </el-form-item> -->
          <!--历史日志end-->
          <el-form-item label="">
            <el-input
              v-model="searchForm.value"
              clearable
              style="width: 316px"
              :placeholder="$t('logs.searchInputTaskName')"
              @keyup.enter.native="handleSearch"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-search cursor-p"
                @click="handleSearch"
              />
            </el-input>
          </el-form-item>

          <!-- 添加角色按钮 -->
          <!-- <el-form-item class="float-right" style="margin-right: 0">
            <el-button type="primary" class="normal-btn more-btn">
              <svg-icon icon-class="export" class="export-icon"></svg-icon>
              {{ $t("logs.exportLog") }}
            </el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <!-- 搜索框 end-->
      <!-- 主体内容 start-->
      <CustomTable
        ref="customTable"
        :loading="loading"
        :table-data="tableData"
        :pagination="pagination"
        @handleSizeChange="handlePaginationChange"
        @handleCurrentChange="handlePaginationChange"
      >
        <el-table-column prop="title" :label="$t('logs.taskTitle')" />
        <el-table-column prop="module" :label="$t('logs.systemModule')"></el-table-column>
        <el-table-column prop="requestState" :label="$t('logs.executeStatus')">
          <template slot-scope="scope">
            <log-status :status="scope.row.requestState === 'SUCCEED' ? 'success' : 'danger'">
              {{ transStatus(scope.row.requestState) }}
            </log-status>
          </template>
        </el-table-column>
        <el-table-column
          prop="logContent"
          show-overflow-tooltip
          :label="$t('logs.logInformation')"
        ></el-table-column>
        <el-table-column prop="createTime" :label="$t('logs.createTime')" />
        <el-table-column :label="$t('public.operation')" width="100">
          <template slot-scope="scope">
            <el-button class="cursor-p" type="text" @click="handleShowLogsDetails(scope.row)">
              {{ $t('common.view') }}
            </el-button>
          </template>
        </el-table-column>
      </CustomTable>
      <!-- 主体内容 end-->

      <!-- 明细内容start -->
      <log-details-dialog
        :visible.sync="detailsFlag"
        :dialog-data="logDetails"
        @success="handleUpdateList"
      />
      <!-- 明细内容end -->
    </div>
  </div>
</template>

<script>
import LogDetailsDialog from "../components/log-details-dialog";
import LogStatus from "../components/log-status";
import { getDictionary } from "@/api/common";

import LogsApi from "@/api/logs";
// 初始化查询条件
function initSearchParams() {
  return {
    value: "",
    module: "",
    title: "",
    timeArray: [],
    operator: "",
    logType: "",
    requestState: "",
    logTypes: "JOB" // 类型
  };
}
export default {
  name: "JobList",
  components: {
    LogDetailsDialog,
    LogStatus
  },
  props: {
    isInit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchForm: {
        value: "",
        module: "",
        title: "",
        timeArray: [],
        operator: "",
        logType: "",
        requestState: "",
        logTypes: "JOB" // 类型
      },
      operateType: [],
      operateStatus: [],
      loading: false,
      detailsFlag: false,
      logDetails: {},
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      tableData: [],
      showSearchMore: false
    };
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
    // 1.获取列表数据2.获取操作类型字典3.获取操作状态字典
    this.startSearch();
    this.getOperateType();
    this.getOperateStatus();
  },
  methods: {
    // 获取列表数据
    startSearch() {
      this.loading = true;
      const [startDate, endDate] = this.searchForm.timeArray;
      const parmas = {
        size: this.pagination.pageSize,
        page: this.pagination.pageNum,
        logTypes: this.searchForm.logTypes,
        startDate: startDate || "",
        endDate: endDate || "",
        "orders[0].asc": "false",
        "orders[0].column": "createTime"
      };
      if (this.searchForm.module) {
        parmas.module = this.searchForm.module;
      }
      if (this.searchForm.operator) {
        parmas.operator = this.searchForm.operator;
      }
      if (this.searchForm.logType) {
        parmas.logType = this.searchForm.logType;
      }
      if (this.searchForm.requestState) {
        parmas.requestState = this.searchForm.requestState;
      }
      LogsApi.getLogsList(parmas).then(res => {
        this.loading = false;
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.tableData = records;
          this.pagination.total = Number(total);
        }
      });
    },
    // 获取操作类型字典
    getOperateType() {
      getDictionary({ code: "OPERATER_OPERATER_TYPE" }).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.operateType = res.data.dictItems;
          }
        }
      });
    },
    // 获取操作状态字典
    getOperateStatus() {
      getDictionary({ code: "LOG_OPERATER_STATUS" }).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.operateStatus = res.data.dictItems;
          }
        }
      });
    },
    // 格式化操作方式列
    transLogType(type) {
      for (let i = 0; i < this.operateType.length; i++) {
        if (this.operateType[i].dictValue === type) {
          return this.operateType[i].dictLabel;
        }
      }
    },
    // 格式化操作状态数据
    transStatus(status) {
      if (status === "SUCCEED") {
        return "成功";
      } else {
        return "失败";
      }
    },
    // 显示日志详情数据
    handleShowLogsDetails(val) {
      if (val.logType) {
        val.logType = this.transLogType(val.logType);
      }
      if (val.requestState) {
        val.requestState = this.transStatus(val.requestState);
      }
      this.logDetails = val;
      this.detailsFlag = true;
    },
    // 搜索
    handleSearch() {
      this.tableData = [];
      this.pagination.total = 0;
      this.pagination.pageNum = 1;
      this.startSearch();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.startSearch();
    },
    // 页数改变
    handleCurrentChange(val) {
      this.current = val;
      this.startSearch();
    },
    handleUpdateList() {
      this.startSearch();
    },
    // 重置参数，只是单纯重置参数，不走查询
    handleResetSearch() {
      this.searchForm = initSearchParams();
      this.startSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.padding24 {
  padding: 24px 24px 0;
}
.content-wrap {
  background: #fff;
  margin-top: 8px;
  height: calc(100% - 90px);
}
.search {
  background: #fff;
}
.content-table-top {
  position: relative;
  margin-bottom: 24px;
  .content-table-top-export {
    position: absolute;
    top: -6px;
    right: 0px;
  }
}
.more-btn {
  width: 104px;
  height: 40px;
}
.export-btn {
  width: 128px;
  height: 40px;
}
</style>
